import orderBy from "lodash/orderBy";

import {Part} from "../part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {showerThumbnail} from '../../../bvComponent/core/assets';

// import store from "../../../../store";

import {ShowerTubCombo} from "./showerTubCombo";

import ShowerFixture from "../subparts/shower/showerFixture";
import ShowerGlass from "../subparts/shower/showerGlass";
// import ShowerOverlay from "../subparts/shower/showerOverlay";
import ShowerBody from "../subparts/shower/showerBody";
import ShowerWall from "../subparts/shower/showerWall";
import ShowerWallAccent from "../subparts/shower/showerWallAccent";
import ShowerDoor from "../subparts/shower/showerDoor";
import ShowerPanCombo from "../subparts/shower/showerPanCombo";
import ShowerDoorHandle from "../subparts/shower/showerDoorHandle";
import PonyWallCap from "../subparts/shower/ponyWallCap";
import PonyWallGlass from "../subparts/shower/ponyWallGlass";
import ShowerFloor from "../subparts/shower/showerFloor";
import Threshold from "../subparts/shower/threshold";
import ShowerDrain from "../subparts/shower/showerDrain";
import ShowerHead from "../subparts/shower/showerHead";

export class Shower extends Part {
  static id = 'Shower';

  static Type = {
    Custom: 'Custom',
    Complete: 'Complete',
    Combo: 'Combo',
    All: 'All'
  };

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerThumbnail;
    this.partName = 'Shower';
    this.translateId = "visualizer.bathroom.shower";
    this.relatedItems = [];
    this.activeSubType_ = Shower.Type.Custom;

    this.customBodyType = 1; // Door

    this.showerBody = null;
    this.showerGlass = null;
    this.showerWall = null;
    this.showerWallAccent = null;

    // old
    this.showerFloor = null;
    this.showerOverlay = null;
    // old

    this.showerPanCombo = null;
    this.threshold = null;
    this.showerFixture = null;
    this.showerBodySelectedByUser = false;
    this.showerDoor = null;
    this.showerDoorHandle = null;

    this.ponyWallCap = null;
    this.ponyWallGlass = null;

    this.showerBody = new ShowerBody(true);
    this.showerBody.getParent = () => this;
    this.showerBody.type = Shower.Type.All;
    this.showerBody.counts = {
      allLayoutFeaturesCount: 0,
      largeLayoutFeaturesCount: 0,
      smallLayoutFeaturesCount: 0
    };
    this.relatedItems.push(this.showerBody);

    this.showerFloorIsActive = false;

  }

  load(dbFeature) {
    let relatedItemName = "",
      relatedItemType = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Shower Pan":
      case "Shower Pans":
        relatedItemName = "showerPanCombo";
        RelatedItemClass = ShowerPanCombo;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Wall":
      case "Shower Walls":
      case "ShowerInteriorWall": // OLD
        relatedItemName = "showerInteriorWall";
        RelatedItemClass = ShowerWall;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Wall Accent":
        relatedItemName = "showerWallAccent";
        RelatedItemClass = ShowerWallAccent;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Door":
      case "Shower_Door":
        if (!dbFeature.displayName.includes("Neo Angle")) {
          relatedItemName = "showerDoor";
          RelatedItemClass = ShowerDoor;
          relatedItemType = Shower.Type.Custom;
        }
        break;
      case "Shower Door Handle":
        relatedItemName = "showerDoorHandle";
        RelatedItemClass = ShowerDoorHandle;
        relatedItemType = Shower.Type.Custom;
        break;
      case "ShowerPan":
        relatedItemName = "threshold";
        RelatedItemClass = Threshold;
        relatedItemType = Shower.Type.Custom;
        break;
      case "ShowerFloor":
        relatedItemName = "showerFloor";
        RelatedItemClass = ShowerFloor;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Fixture":
        relatedItemName = "showerFixture";
        RelatedItemClass = ShowerFixture;
        relatedItemType = Shower.Type.All;
        break;
      case "Shower Drain":
        relatedItemName = "showerDrain";
        RelatedItemClass = ShowerDrain;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Head":
        relatedItemName = "showerHead";
        RelatedItemClass = ShowerHead;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Pony Wall Cap":
        relatedItemName = "ponyWallCap";
        RelatedItemClass = PonyWallCap;
        relatedItemType = Shower.Type.All;
        break;
      case "Pony Wall Glass":
        relatedItemName = "ponyWallGlass";
        RelatedItemClass = PonyWallGlass;
        relatedItemType = Shower.Type.All;
        break;
      case "Shower Glass":
        if (!this.showerBody) {
          this.showerBody = new ShowerBody(true);
          this.relatedItems.push(this.showerBody);
        }
        relatedItemName = "showerGlass";
        RelatedItemClass = ShowerGlass;
        relatedItemType = Shower.Type.Custom;
        break;
      // case "Shower Overlay":
      //   relatedItemName = "showerOverlay";
      //   RelatedItemClass = ShowerOverlay;
      //   relatedItemType = Shower.Type.Custom;
      //   break;
      case "Shower Body":
        relatedItemName = "showerBody";
        RelatedItemClass = ShowerBody;
        relatedItemType = Shower.Type.Custom;
        break;

    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].type = relatedItemType;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  setSpecificRules() {}

  // setLayers(layout, placeholdersNeeded) {
  //   let res = [];
  //   const relatedItems = this.getRelatedItems();
  //   // console.log('relatedItems', relatedItems);
  //   relatedItems.forEach(relatedItem => {
  //     relatedItem.setLayers(layout);
  //   });
  //   if (this.showerDoor && !this.showerDoor.activeFeature) {  // we need it cause shower door is relying on shPanCombo
  //     this.showerDoor.setLayers(layout);
  //   }
  //   if (this.showerDoorHandle && !this.showerDoorHandle.activeFeature) {
  //     this.showerDoorHandle.setLayers(layout);
  //   }
  //   relatedItems.forEach(relatedItem => {
  //
  //     (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
  //       ? relatedItem.placeholderFeature.layer.addTo(res)
  //       : relatedItem.activeFeature && relatedItem.activeFeature.layer ? relatedItem.activeFeature.layer.addTo(res) : null
  //
  //     // NN(relatedItem.activeFeature, (activeFeature) => activeFeature.layer.addTo(res));
  //
  //     if ((relatedItem instanceof ShowerBody || relatedItem instanceof ShowerInteriorWallAccent)
  //       && relatedItem.activeFeatureParts && relatedItem.activeFeatureParts.length) {
  //       relatedItem.activeFeatureParts.forEach((activeFeaturePart) => {
  //         activeFeaturePart && !activeFeaturePart.disabled && activeFeaturePart.layer && activeFeaturePart.layer.addTo(res);
  //       })
  //     }
  //     if (relatedItem instanceof ShowerWall && relatedItem.activeFeatureParts && relatedItem.placeholderChanged && relatedItem.activeFeatureParts.length) {
  //       relatedItem.activeFeatureParts.forEach((activeFeaturePart) => {
  //         activeFeaturePart && !activeFeaturePart.disabled && activeFeaturePart.layer && activeFeaturePart.layer.addTo(res);
  //       })
  //     }
  //
  //   });
  //
  //   return res.length ? res : null;
  // }

  subTypes() {
    return this.showerBody && (this.showerBody.features.some(showerBodyFeature => showerBodyFeature.type === 0)
      && this.showerBody.features.some(showerBodyFeature => showerBodyFeature.type === 1)) ? [
      Shower.Type.Custom,
      Shower.Type.Complete,
    ] : []
  }

  isSubTypeWithItems() {
    return true;
  }

  activeSubType() {
    return this.activeSubType_;
  }

  handleSubTypeClick(subType, handleNavigationItemClick) {
    this.activeSubType_ = subType;
    this.showerBody.setDefault();   // set default custom shower
    if (handleNavigationItemClick) {
      handleNavigationItemClick(this.showerBody.navigationSubItems()[0]) // set default custom shower
    }
  }

  getRelatedItems() {
    const relatedItems = orderBy(this.relatedItems, 'layerPriority');
    if (this.showerTubComboIsActive()) {
      return relatedItems
    }
    return relatedItems.filter((relatedItem) => {
      return relatedItem.type === this.activeSubType_ || relatedItem.type === Shower.Type.All
    })
  }

  subParts() {
    const activeShowerGroup = this.getActiveShowerGroup();
    const ponyWallIsActive = activeShowerGroup.showerDimensions() === "Pony";
    return this.getRelatedItems()
      .filter(item => {
        if (item.isPonyWallPart) {
          item.visible = ponyWallIsActive
        }
        return item.visible
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
    // return filter(this.relatedItems, {visible: true}).map(_ => new DesignNavigationItem(_.partName, _));
  }

  //
  // toggleShowerParts(disabled, keepLeftWall) {
  //   this.getRelatedItems().forEach((relItem) => {
  //     console.log('relItem', relItem);
  //     if (
  //       relItem.partId !== "shower_interior_wall"
  //       && relItem.partId !== "shower_wall_accent"
  //       && relItem.partId !== "shower_fixture"
  //       && relItem.partId !== "shower_door"
  //       && relItem.partId !== "shower_door_handle"
  //       && relItem.partId !== "pony_wall"
  //       && relItem.partId !== "pony_wall_cap"
  //       && relItem.partId !== "pony_wall_glass"
  //     ) {
  //       relItem.disabled = disabled;
  //     }
  //   });
  //   if (!keepLeftWall) {
  //     this.layout.parts.Walls.wallExL.disabled = disabled;
  //   }
  // }

  setDefault(layout) {
    const relatedItems = orderBy(this.relatedItems, 'layerPriority');
    relatedItems.forEach(_ => _.setDefault(layout));
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  handleSubPartClick() {

  }

  /**
   * Gets the current shower size from metaValues.
   */
  showerSize() {
    if (!this.showerBody || !this.showerBody.activeFeature) {
      return null;
    }
    let showerSizeValues = this.showerBody.activeFeature.metaData["ShowerSize"];
    if (!showerSizeValues || !showerSizeValues.length) {
      if (this.showerBody.activeFeature.partName.includes("Complete")) {
        showerSizeValues = ['30'];
      } else {
        console.warn('No Shower size.');
      }
    } else if (showerSizeValues[0] === "-") {
      showerSizeValues[0] = this.showerBody.activeFeature.partName.includes("60in") ? "60" : "30"
    }

    return showerSizeValues[0];
  }

  /**
   * Gets the current shower dimensions from showerBody
   */
  showerDimensions() {
    if (!this.showerBody)
      return "Full";
    return this.showerBody.activeFeature ? this.showerBody.activeFeature.showerDimensions : null;
    // "Full" : "Half";
  }

  isComplete() {
    if (!this.showerBody) {
      return true;
    } else if (this.showerTubComboIsActive()) {
      return false;
    } else {
      return this.showerBody.activeFeature
    }
  }

  showerTubComboIsActive() {
    const comboPart = this.layout.parts[ShowerTubCombo.id];
    return comboPart && comboPart.showerTubComboIsActive
  }

  getActiveShowerGroup() {  // user for taking sizes, etc...
    return this.showerTubComboIsActive() ? this.layout.parts[ShowerTubCombo.id] : this;
  }
}

